import styled from 'styled-components';
import { Paper, Card } from '@material-ui/core';
import CloudDownload from '@material-ui/icons/CloudDownload';

export const RootContainer = styled.div`
  display: 'flex',
  flex-direction: 'column',
  min-height: '100vh',
`;

export const Footer = styled(Card)`
  padding: 16px;
  margin-top: auto;
  height: 10vh;
  background-color: white;
`;

export const Title = styled.h1`
  font-size: 3em;
  margin-top: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CustomPaper = styled(Paper)`
  padding: 2px;
`;

const getStateColors = state => {
  if (state.product.errorsItem && state.product.errorsItem.length > 0) {
    return '3px solid #f50057';
  }
  return '3px solid #5ccaf4';
};

const getColor = state => {
  if (state.isDragAccept) {
    return '#00e676';
  }
  if (state.isDragReject) {
    return '#ff1744';
  }
  if (state.isDragActive) {
    return '#2196f3';
  }
  return '#eeeeee';
};

export const CardContainer = styled(Card)`
  padding: 10px;
  margin: 16px;
  border: ${props => getStateColors(props.state)};
`;

export const Container = styled.div`
  height: 200px;
  margin: 35px;
  border-width: 2px;
  border-radius: 2px;
  border-color: ${props => getColor(props.state)};
  border-style: dashed;
  background-color: #fff;
  outline: none;
  transition: border 0.24s ease-in-out;
  cursor: pointer;
  text-align: center;
`;

export const Exemple = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

Exemple.Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  margin-bottom: 20px;
`;

Exemple.Icon = styled(CloudDownload)`
  font-size: 2.8em;
  margin-top: 8px
  margin-bottom: 15px;
`;
